import React from 'react';
import { Button } from '~/UIKit';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { Theme, useMediaQuery } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import { useTranslation } from 'react-i18next';
import { FONT_SIZE_INBETWEEN } from '~/Constants/UI.constants';

export interface IPrivateLayoutTitleWithAction {
  title: string;
  actionName?: string;
  simpleTitle?: boolean;
  onAddButtonClick?: () => void;
  mobileActionName?: string;
  moreActions?: JSX.Element;
  actionDisabled?: boolean;
}

const useStyles = makeStyles(() => ({
  PrivateLayoutTitleWithActionWrapper: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    justifyContent: 'space-between',
  },
  PrivateLayoutTitleWithActionAddIcon: {
    border: `1px solid ${PRIMARY_BLUE}`,
    width: '30px',
    height: '30px',
    color: PRIMARY_BLUE,
  },
  PrivateLayoutTitleWithActionText: {
    paddingRight: '15px',
    maxWidth: 'calc(100% - 50px)',
    overflow: 'hidden',
  },
  button: {
    fontSize: FONT_SIZE_INBETWEEN,
  },
}));

export const PrivateLayoutTitleWithAction = ({
  title,
  actionName,
  simpleTitle,
  onAddButtonClick,
  mobileActionName,
  moreActions,
  actionDisabled,
}: IPrivateLayoutTitleWithAction) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  if (simpleTitle) {
    return <>{title}</>;
  }

  const actionButton = mobile ? (
    <Button
      onClick={onAddButtonClick}
      size={'small'}
      variant="contained"
      className={classes.button}
      disabled={actionDisabled}
    >
      {mobileActionName || `+ ${actionName}`}
    </Button>
  ) : (
    <Button
      onClick={onAddButtonClick}
      size={'medium'}
      variant="contained"
      className={classes.button}
      disabled={actionDisabled}
    >
      {actionName || `+ ${t('app.add')}`}
    </Button>
  );

  return (
    <div className={classes.PrivateLayoutTitleWithActionWrapper}>
      <span className={classes.PrivateLayoutTitleWithActionText}>{title}</span>
      <span className={classes.PrivateLayoutActionSection}>
        {!!moreActions && !mobile && moreActions}
        {!!actionName && actionButton}
      </span>
    </div>
  );
};
